<template>
  <!-- <main class="list-table mt-5"> -->
  <main class="list-table mt-5">
    <div class="row">
      <div class="col-md-12 text-right">
        <div class="">
          <button
            @click="downloadTable"
            class="btn-download mr-5"
          >{{ $t("events.listEvents.donwloadBtn") }}</button>
        </div>
      </div>
      <div class="col-md-12">
        <v-server-table
          :columns="table_options.columns"
          :options="table_options.options"
          ref="travelFinishedTable"
          id="travelFinishedTable"
          class="mt-5"
        >
          <template #actions="props">
            <!-- <i class="far fa-eye"></i> -->
              <!-- Detail -->
            <router-link
              class="edit-btn"
              :to="{
                name: 'Trip Details',
                params: {
                  id: props.row.id,
                  travelStatus: props.row.travelStatus,
                  data: props.row,
                  details: true,
                  tripDone: true,
                  onGoingOrDone: true,
                }
              }"
            >
              <i class="far fa-eye"></i>
            </router-link>
          </template>
        </v-server-table>
      </div>
    </div>
  </main>
</template>

<script>
import API_SERVICE from "@/lib/api/QRAccess.js";
const api = new API_SERVICE();

export default {
  data() {
    return {};
  },
  methods: {
    downloadTable: async function(event) {
      // console.log('Download init travel table')
      const filterParams = this.$refs.travelFinishedTable;
      this.$store.commit("global/SET_LOADING", true);
      try {
        filterParams.query.travelStatus = 'travelFinished';
        const resp = await api.downloadTravelsTable(filterParams);
        let anchor = document.createElement("a");
        anchor.href = resp.url;
        anchor.target = "_blank";
        anchor.click();
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      }
    }
  },
  computed: {
    travelFinishedTable: function() {
      return this.$refs.travelFinishedTable;
    },
    table_columns: function() {
      return [
        "id",
        "driverFullName",
        "controlNumber",
        "workingShift",
        "busRouteName",
        "busNumber",
        "busDirection",
        "totalPassengers",
        "checkinDate",
        "actions"
      ];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(`qrAccess.travels.table.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(column => column !== "actions");
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: false,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [
            "id",
            "driverFullName",
            "controlNumber",
            "workingShift",
            "busRouteName",
            "busNumber",
            "busDirection",
            "totalPassengers"
          ],

          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort"
          },
          resizableColumns: false,
          perPageValues: [25, 50, 100],
          perPage: 25,
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler")
          },

          requestAdapter: function(data) {
            const queries = {};
            queries.page = data.page - 1;
            queries.limit = data.limit;
            queries.query = data.query;
            //   queries.orderBy = data.orderBy ? data.orderBy : "folio";
            //   queries.orderType = data.ascending ? "asc" : "desc";
            return queries;
          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {
              data.query.travelStatus = 'travelFinished';
              const resp = await api.getAllTravels(data);
              this.$store.commit("global/SET_LOADING", false);
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.travels,
              count: response.total
            };
          }
        }
      };
    }
  },
};
</script>

<style lang="scss" scoped>
  .btn-download {
    padding: 0.5rem 2rem;
    background: #000;
    color: #fff;
    border: none;
    border-radius: 0px;
  }
  .actionsDrivers {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
  .actionsDrivers > *, button {
    cursor: pointer;
  }
  .actionsDrivers > .edit-btn {
    color: #000000;
    transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
    &:hover {
      color: #000000;
    }
  }
  .VueTables .dropdown {
    margin: 1rem 0;
  }
  .VueTables__columns-dropdown {
    float: initial !important;
  }
  .VueTables__columns-dropdown > button {
    color: #000 !important;
    background-color: transparent !important;
    border: 1px solid #000 !important;
    border-radius: 0 !important;
    padding: 5px 10px !important;
  }
  .VueTables .dropdown .dropdown-menu {
    padding: 1rem;
  }
  .VueTables .dropdown .dropdown-menu a {
    color: #000;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .VueTables .dropdown .dropdown-menu a > input {
    margin-right: 0.5rem;
  }
</style>
